import React from "react";

function Home() {
  return (
    <div>
      Click <span className="text-primary font-bold">"Plan a trip"</span> in the
      header
    </div>
  );
}

export default Home;
